import './styles/theme.css';
import Summary from './components/summary/Summary';
import { useLocation } from '@tanstack/react-router';

type SummaryPageProps = {
  showAdminFilters?: boolean;
};

export const SummaryPage = ({ showAdminFilters = true }: SummaryPageProps) => {
  const { pathname } = useLocation();
  return <Summary key={pathname} showAdminFilters={showAdminFilters} />;
};
